import React from "react";
import { Tag } from "primereact/tag";
import { formatDateTime } from "../../../../algorithms/date";

const STATUS_CONFIG = [
  { label: "Pending", tailwind: "bg-blue-500" },
  { label: "Removed", tailwind: "bg-gray-500" },
  { label: "Cleared Out", tailwind: "bg-purple-500" },
  { label: "Claimed", tailwind: "bg-green-500" },
  { label: "Cancelled", tailwind: "bg-slate-500" },
  { label: "Take-Back", tailwind: "bg-orange-500" },
  { label: "Revoked", tailwind: "bg-red-700" },
  { label: "Overstay", tailwind: "bg-yellow-500" },
  { label: "For RTS", tailwind: "bg-orange-500" },
  { label: "RTS Overstay", tailwind: "bg-red-500" },
  { label: "RTS", tailwind: "bg-red-700" },
];

const packageStatusHelper = (label) => {
  const found = STATUS_CONFIG.find((s) => s.label === label);
  return found
    ? `${found.tailwind} text-center border-0 text-white`
    : "border-0 text-center text-white bg-gray-400";
};

const PackageCard = ({ row }) => {
  const handleCardClick = () => {
    if (row.packageId) {
      window.open(
        `/view-package-history/${row.packageId}/${row.userAccountId}`,
        "_blank",
      );
    }
  };

  const handleCourierClick = (e) => {
    e.stopPropagation();
    if (row.partnerAgentId) {
      window.open(`/agents/${row.partnerAgentId}`, "_blank");
    }
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col gap-2 shadow-sm active:bg-gray-50 transition-colors cursor-pointer"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-gray-800 break-all leading-snug">
            {row.waybillNumber || "(Storage)"}
          </div>
        </div>

        <Tag
          className={`text-xs font-semibold shrink-0 ${packageStatusHelper(row.packageStateLabel)}`}
        >
          {row.packageStateLabel}
        </Tag>

        <button
          onClick={handleCardClick}
          title="View Package Details"
          className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-400 hover:text-blue-600 hover:border-blue-200 hover:bg-blue-50 transition-all duration-150 shrink-0"
        >
          <svg
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
            />
          </svg>
        </button>
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
        <div>
          <p className="text-gray-400 mb-0.5 font-medium">Dropoff Date</p>
          <p className="font-semibold text-gray-700">
            {formatDateTime(row.packageDate)}
          </p>
        </div>
        <div>
          <p className="text-gray-400 mb-0.5 font-medium">Locker Location</p>
          <p className="font-semibold text-gray-700">
            {row.lockerLocation || "—"}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
        <div className="col-span-2">
          <p className="text-gray-400 mb-0.5 font-medium">Courier Mobile</p>
          <p
            className="font-semibold text-blue-600 underline underline-offset-2 cursor-pointer hover:text-blue-800"
            onClick={handleCourierClick}
          >
            {row.partnerAgentMobile || "—"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
